module.exports = __webpack_public_path__ + "media/images/webpage/shared/spotmap/location__hotel-d1aa2816d9eda7d3e171f2a895df9a80.svg";